"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_360__degrees(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a0d4c4a2-becc-410f-bf73-0f98f71f7430",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 161.86 89.2"
  }, props), /*#__PURE__*/React.createElement("title", null, "360-view"), /*#__PURE__*/React.createElement("path", {
    d: "M165.86,86.87C170.44,90.71,173,95,173,99.5c0,16.55-34.44,30-76.93,30-3.67,0-9.09.19-12.63,0",
    transform: "translate(-15.14 -59)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,126.92c-27-4.65-45.83-15.18-45.83-27.42,0-8,8-15.25,21.13-20.63",
    transform: "translate(-15.14 -59)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "83.04 85.2 68.31 70.47 83.04 55.73",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,63.4H71.5S62,73.4,60,78.9h2c6.6,0,11.5,3.9,11.5,10.5h0c0,6.6-4.9,11-11.5,11h0a20.13,20.13,0,0,1-10.19-3",
    transform: "translate(-15.14 -59)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,63.4C96,63.9,88.35,72,87,81.9c-1.38,10.12.78,18.5,11,18.5,0,0,9.93.55,9-13-1-14.5-20-5.5-20-5.5",
    transform: "translate(-15.14 -59)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,81.7c0,10.33-3.5,18.7-11.5,18.7C123,100.4,119,92,119,81.7S123,63,130.5,63,142,71.37,142,81.7Z",
    transform: "translate(-15.14 -59)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.36,
    cy: 10.4,
    r: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var _default = ic_360__degrees;
exports.default = _default;